<h1>draggable directive <small>(jQuery UI)</small></h1>


<div id="first-box" class="box" appDraggable>
  Drag me!
</div>


<div id="second-box" class="box" appDraggable>
  Drag me too!
</div>
